import { render, staticRenderFns } from "./Profiling.vue?vue&type=template&id=18d0cd48&scoped=true&"
import script from "./Profiling.vue?vue&type=script&lang=js&"
export * from "./Profiling.vue?vue&type=script&lang=js&"
import style0 from "./Profiling.vue?vue&type=style&index=0&id=18d0cd48&scoped=true&lang=css&"
import style1 from "./Profiling.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18d0cd48",
  null
  
)

export default component.exports